export class FeatureFlags {
    public static Application = 'application';
    public static CustomersTour = 'customers-tour';
    public static GuidedTour = 'guided-tour';
    public static RequestFundsTips = 'request-funds-tips';
    public static ShareReport = 'share-report';
    public static UploadInvoicesTour = 'upload-invoices-tour';
    public static ViewLogs = 'view-logs';
    public static Chat = 'chat';
    public static AdminCreateBuyer = 'admin-create-buyer';
    public static AdminSupplierActiveToggle = 'admin-supplier-active-toggle';
    public static AdminUserManagement = 'admin-user-management';
    public static SupplierBuyersPage = 'supplier-buyers-page';
    public static BuyerExperienceAnalyticsOverview = 'buyer-experience-analytics';
    public static BuyerExperienceAnalyticsInsights = 'buyer-experience-analytics-insights';
    public static AdminManageProspects = 'admin-manage-prospects';
    public static PendingCreditMemos = 'pending-credit-memos';
    public static SellerReportCenter = 'seller-report-center';
    public static SupplierDetailsForBuyers = 'supplier-details-for-buyers';
    public static PendingCreditMemosDetails = 'pending-credit-memos-details-pages';
    public static BuyerInvoicesKPIs = 'buyer-invoices-kpis';
    public static ListFundingBatchSummaryPerformance = 'list-funding-batch-summary-performance';
    public static CountryCodePhoneInput = 'country-code-phone-input';
    public static RevokeCreditMemo = 'revoke-credit-memo';
    public static RelationshipLevelFlatFee = 'relationship-level-flat-fee';
    public static ResetEnrollment = 'reset-enrollment';
    public static ForgotPasswordEnhancement = 'forgot-password-enhancement';
    public static AdminClaims = 'admin-claims';
    public static InternationalWiresPhase1 = 'international-wires-phase-1';
    public static InternationalWiresTransmissionFee = 'international-wires-transmission-fee';
    public static TotpMfa = 'totp-mfa';
    public static NewManageSupplierImplementationTab = 'new-manage-supplier-implementation-tab';
    public static BuyerPaidEarlyPaymentPercentage = 'buyer-paid-early-payment-percentage';
    public static BuyerPaidEarlyPaymentTransferFee = 'buyer-paid-early-payment-transfer-fee';
    public static SupplierPaidEarlyPaymentPercentage = 'supplier-paid-early-payment-percentage';
    public static SupplierPaidEarlyPaymentTransferFee = 'supplier-paid-early-payment-transfer-fee';
    public static LsqMfa = 'lsq-mfa';
    public static MaxDaysEarly = 'max-days-early';
    public static PayLater = 'pay-later';
    public static PayLaterAdministration = 'pay-later-administration';
    public static SCFReinviteMidEnroll = 'scf-reinvite-mid-enroll';
    public static BuyerAccountInvoiceDetails = 'buyer-account-invoice-details';
    public static BuyerAccountPaymentsPage = 'buyer-account-payments-page';
    public static DocumentCenter = 'document-center';
    public static ArInsightsReportDownloads = 'ar-insights-report-downloads';
    public static LegalEntityConnection = 'legal-entity-connection';
    public static HistoricalAvailabilityReport = 'historical-availability-report';
    public static ArInsights = 'ar-insights';
    public static FundsOutstandingFeeStatement = 'funds-outstanding-fee-statement';
    public static PurchaseRequestsUI = 'purchase-requests-ui';
}
